import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import MDBox from 'components/MDBox';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'layouts/LayoutContainers/DashboardLayout';

// Images

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar objectName="Access denied" />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          minHeight: 'calc(100vh - 260px)',
        }}>
        <MDBox
          sx={{
            backgroundColor: '#fff5f5',
            border: '1px solid #f5b5b5',
            borderLeft: '6px solid #d32f2f',
            boxShadow: '0px 10px 28px rgba(120, 0, 0, 0.18)',
            maxWidth: 520,
            width: '100%',
            position: 'relative',
          }}
          borderRadius="lg"
          p={4}
          mb={1}
          textAlign="center">
          <MDBox
            sx={{
              position: 'absolute',
              top: 16,
              left: 16,
              color: '#d32f2f',
              lineHeight: 0,
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              fill="currentColor"
              className="bi bi-exclamation-triangle"
              viewBox="0 0 16 16"
              aria-hidden="true">
              <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
              <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
            </svg>
          </MDBox>
          <Typography variant="overline" fontWeight="bold" sx={{ color: '#b71c1c', letterSpacing: 0, fontSize: '1rem' }}>
            Unauthorized
          </Typography>
          <Typography variant="h3" fontWeight="bold" sx={{ color: '#7f1d1d' }} mb={1}>
            Access denied
          </Typography>
          <Typography variant="body1" sx={{ color: '#4a1f1f' }} mb={3}>
            You do not have access to the requested page.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
            <Button
              variant="contained"
              onClick={() => navigate(-1)}
              sx={{
                backgroundColor: '#b71c1c',
                color: '#ffffff',
                '&:hover': { backgroundColor: '#8f1515' },
              }}>
              Back
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/home')}
              sx={{
                borderColor: '#b71c1c',
                color: '#7f1d1d',
                '&:hover': {
                  borderColor: '#8f1515',
                  backgroundColor: '#ffe3e3',
                },
              }}>
              Home
            </Button>
          </Stack>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
};

export default Unauthorized;
